// @flow
import React, { Component } from 'react'
import moment from 'moment'
import { Redirect, withRouter } from 'react-router-dom'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Path from 'routes/path'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import { actions as UserActions } from 'redux/modules/remote/user'
import CardHelper from 'helpers/CardHelper'

import MainTemplate from 'components/templates/MainTemplate'
import LoadingView from 'components/atoms/LoadingView'
import ReservationChangePaymentPage from 'components/pages/ReservationChangePaymentPage'
import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'
import { getBillStatementCurrentProps } from 'components/molecules/BillStatementCurrent/presenter'
import { getSelectCreditCardProps } from 'components/organisms/SelectCreditCardSection/presenter'

import graphql from './graphql'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
      reservationId: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading?: ?boolean,
    confirmActionType?: ?'approve' | 'reject',
    isShowContentsSp?: ?boolean,
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
    fetchUser: Function,
    fetchPayments: Function,
    recalcGuestAmount: Function,
    payReservation: Function,
    postPayment: Function,
    removePoint: Function,
    removeCoupon: Function,
  },
  user: {
    payments: Array<{}>,
  },
  reservationDetail: ReservationDetailState,
}

class ReservationChangePaymentPageContainer extends Component<PropTypes, *, *> {
  requestParams: Object

  componentDidMount() {
    const { actions, reservationDetail, match, data } = this.props
    const { detail, messages } = reservationDetail

    window.scrollTo(0, 0)

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    actions.setUIState(containerIds.RESERVATION_DETAIL, {
      hasChanged: false,
    })

    actions.fetchPayments({
      userId: data.viewer.id,
    })
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, reservationDetail, history, match, user } = this.props
    const {
      reservationDetail: prevReservationDetail,
      user: prevUser,
    } = prevProps

    // 予約に紐づくカード選択をデフォルトセット
    const reservation = reservationDetail.detail
    if (
      (reservation.id && !prevReservationDetail.detail.id) ||
      (reservation.id &&
        prevReservationDetail.detail.id &&
        user.payments.length > 0 &&
        prevUser.payments.length === 0)
    ) {
      const reservedBilling = reservation.billing || {}
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        selectedCardId: reservedBilling.post_payment_id,
      })
    }
  }

  generatePageProps = () => {
    const { user, ui, reservationDetail, actions, data, config } = this.props
    const currentUser = data.viewer || {}
    const cardHelper = new CardHelper(config)

    return {
      isShowContentsSp: true,
      sidebarInbox: <ReservationSidebarContainer />,
      selectCreditCardSectionProps: getSelectCreditCardProps(
        user,
        currentUser,
        cardHelper,
        ui,
        actions,
      ),
      billStatementCurrentProps: getBillStatementCurrentProps(
        reservationDetail.detail,
      ),
      onClickBack: () => {
        actions.setUIState(containerIds.RESERVATION_DETAIL, {
          redirectToMessage: true,
        })
      },
      onClickChange: () => {
        actions.changePayment({
          userId: currentUser.id,
          reservationId: reservationDetail.detail.id,
          requestParam: { payment_id: ui.selectedCardId },
          onSuccess: () => {
            antdMessage.success(
              i18n.t('page.dashboard.reservation.changePayment.success'),
            )
            actions.setUIState(containerIds.RESERVATION_DETAIL, {
              redirectToMessage: true,
            })
          },
        })
      },
      isChangeButtonDisabled: !ui.hasChanged,
    }
  }

  render() {
    const { match, ui, reservationDetail, actions } = this.props

    if (ui.redirectToMessage) {
      actions.setUIState(containerIds.RESERVATION_DETAIL, {
        redirectToMessage: false,
      })
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    // カード変更できない予約で直リンクした場合はメッセージ画面に戻す
    if (
      reservationDetail.detail.id &&
      !reservationDetail.detail.can_change_card
    ) {
      antdMessage.warning(
        i18n.t('page.dashboard.reservation.error.cannotChangePayment'),
      )
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationChangePayment.title', {
          id: match.params.reservationId || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <ReservationChangePaymentPage {...this.generatePageProps()} />
        {ui.isLoading && <LoadingView />}
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    user: state.user,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
    ...UserActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationChangePaymentPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationChangePaymentPage/index.jsx